import React, { memo, useEffect, useState } from 'react';
import ReactECharts from 'echarts-for-react';

import * as _ from 'lodash';
import { log } from 'utils';

function usePrevious(value) {
  const ref = React.useRef();

  useEffect(() => {
    ref.current = value;
  }, [value]); // Only re-run if value changes

  return ref.current;
}

const _category = ['9:05', '9:10', '9:15', '9:20', '9:25', '9:30', '9:35', '9:40', '9:45', '9:50', '9:55',
                  '10:00', '10:05', '10:10', '10:15', '10:20', '10:25', '10:30', '10:35', '10:40', '10:45', '10:50', '10:55',
                  '11:00', '11:05', '11:10', '11:15', '11:20', '11:25', '11:30',
                  '13:05', '13:10', '13:15', '13:20', '13:25', '13:30', '13:35', '13:40', '13:45', '13:50', '13:55',
                  '14:00', '14:05', '14:10', '14:15', '14:20', '14:25', '14:30', '14:35', '14:40', '14:45', '14:50', '14:55', '15:00'];

function ChartMarketLiquid(props) {
  const DEFAULT_OPTION = {
    grid: { top: 10, right: 15, bottom: 50, left: 40 },
    color: ['#30E820', '#2ECDFF', '#F0B90B', '#F5465C', '#E64DFF'],
    title: {
      show: false,
      text: 'Log Axis',
      left: 'center',
    },
    tooltip: {
      // show: false,
      trigger: 'axis',
      // formatter: '{a} <br/>{b}: {c} ({d}%)',
    },
    legend: {
      bottom: '2%',
      icon: 'roundRect',
      itemGap: 30,
      textStyle: {
        color: props.theme === 'light' ? '#000000' : '#ECECEC',
        fontSize: 12,
        lineHeight: 14,
        padding: [4, 0, 0, 0],
        height: 12,
        fontFamily: 'Roboto',
      },
    },
    xAxis: {
      type: 'category',
      data: [],
      splitLine: {
        show: false,
        lineStyle: {
          type: 'dashed',
          color: '#4E4D62',
          dashOffset: 10,
          opacity: 0.3,
        },
      },
      axisLine: {
        show: false,
      },
      axisTick: {
        show: false,
        alignWithLabel: false,
        length: 3,
      },
      axisLabel: {
        color: props.theme === 'light' ? '#000000' : '#ECECEC',
        fontSize: 8,
        borderColor: props.theme === 'light' ? '#000000' : '#ECECEC',
        rotate: 45,
      },
    },
    yAxis: {
      type: 'value',
      show: true,
      position: 'left',
      alignTicks: true,
      // splitNumber: 4,
      splitLine: {
        // show: false,
        lineStyle: {
          type: 'solid',
          color: '#2E2D3D',
          // dashOffset: 10,
          // opacity: 0.3,
        },
      },
      axisLabel: {
        color: props.theme === 'light' ? '#000000' : '#ECECEC',
        fontSize: 8,
        showMinLabel: true,
        showMaxLabel: true,
        formatter: function (value, index) {
          return value + 'k';
        },
      },
    },
    series: [
      {
        type: 'bar',
        name: props.t('algo.pttt.txt-Current'),
        showSymbol: false,
        data: [],
      },
      {
        type: 'line',
        name: props.t('algo.pttt.txt-PreDay'),
        showSymbol: false,
        data: [],
      },
      {
        type: 'line',
        name: props.t('algo.pttt.txt-1week'),
        showSymbol: false,
        data: [],
      },
      {
        type: 'line',
        name: props.t('algo.pttt.txt-2week'),
        showSymbol: false,
        data: [],
      },
      {
        type: 'line',
        name: props.t('algo.pttt.txt-1month'),
        showSymbol: false,
        data: [],
      },
    ],
  };

  const [option, setOption] = useState(DEFAULT_OPTION);

  const { thanhKhoan, typeOrder } = props;
  const preThanhKhoan = usePrevious(thanhKhoan);
  const preTypeOrder = usePrevious(typeOrder);

  useEffect(() => {
    if (
      thanhKhoan &&
      (!_.isEqual(thanhKhoan, preThanhKhoan) ||
        !_.isEqual(typeOrder, preTypeOrder))
    ) {
      _mapDataToState(thanhKhoan);
    }
  }, [thanhKhoan, typeOrder]);

  function _mapDataToState(res) {
    const newOption = _.cloneDeep(option);

    newOption.xAxis.data = _category;
    if (typeOrder === 'M') {
      newOption.series[0].data = _.filter(res.currVal, o => o > 0);
      newOption.series[1].data = _.filter(res.prevVal, o => o > 0);
      newOption.series[2].data = _.filter(res.week1Val, o => o > 0);
      newOption.series[3].data = _.filter(res.week2Val, o => o > 0);
      newOption.series[4].data = _.filter(res.monthVal, o => o > 0);
    } else {
      newOption.series[0].data = _.filter(res.currPTVal, o => o > 0);
      newOption.series[1].data = _.filter(res.prevPTVal, o => o > 0);
      newOption.series[2].data = _.filter(res.week1PTVal, o => o > 0);
      newOption.series[3].data = _.filter(res.week2PTVal, o => o > 0);
      newOption.series[4].data = _.filter(res.monthPTVal, o => o > 0);
    }

    console.log(newOption);
    newOption.xAxis.axisLabel.color = props.theme === 'light' ? '#000000' : '#ECECEC';
    newOption.yAxis.axisLabel.color = props.theme === 'light' ? '#000000' : '#ECECEC';
    newOption.legend.textStyle.color = props.theme === 'light' ? '#000000' : '#ECECEC';

    setOption(newOption);
  }

  return (
    <ReactECharts
      option={option}
      style={{
        height: '100%',
        width: `100%`,
      }}
    />
  );
}

export default memo(ChartMarketLiquid);
